export const EN = {
    navigation: {
        recents: 'Recents',
        dialpad: 'Dialpad',
        contacts: 'Contacts',
        settings: 'Settings'
    },
    account: 'Account',
    call_preferences: 'Call Preferences',
    conference: 'Conference',
    transfer_call: 'Transfer call',
    add_call: 'Add call',
    help: 'Help',
    about: 'About',
    sound_and_devices: 'Sound & Devices',
    logout: 'Logout',
    search_contact: 'Search contact',
    connectionstate: {
        connecting: 'Connecting...',
        registering: 'Registering...',
        available: 'Available',
        unavailable: 'Unavailable',
        disconnected: 'Disconnected',
        connected: 'Connected'
    },
    no_results: 'No Results',
    unassigned: 'Unassigned',
    call_now: 'Call now',
    transfer_now: 'Transfer now',
    confirm_transfer: 'Do you want transfer call to',
    call_status: {
        finished: 'Finished',
        trying: 'Trying...',
        incoming: 'Incoming...',
        calling: 'Calling...',
        hold: 'Hold'
    },
    hold: 'hold',
    mute: 'mute',
    confirm: 'Confirm',
    transfer: 'transfer',
    merge: 'merge',
    add: 'add',
    keypad: 'keypad',
    swap: 'swap',
    lead: 'lead',
    disable_recording: 'Stop Rec',
    enable_recording: 'Start Rec',
    transfer_to: 'Transfer call to',
    add_to: 'Add new call to',
    hide: 'hide',
    talk_first: 'Talk first',
    extensions_domain: 'Extensions and Domain',
    account_info: 'Account Info',
    change_password: 'Change Password',
    update: 'Update',
    old_pass_ph: 'Enter old password',
    new_pass_ph: 'Provide new password',
    confirm_pass_ph: 'Confirm new password',
    sound_notifications: 'Sound notifications',
    ringtone: 'Ringtone',
    speakers: 'Speakers',
    output: 'Output',
    ringing_device: 'Ringing device',
    microphone: 'Microphone',
    default: 'Default',
    default_device: 'Default device',
    keyboard_shortcuts: {
        enter_pickup: 'Press „Enter” to pick up',
        esc_decline: 'Press „Esc” to decline',
        esc_hangup: 'Press „Esc” to hang up',
        title: 'Keyboard Shortcuts'
    },
    help_items: {
        chat: 'Chat with us',
        report: 'Report an issue'
    },
    email: 'E-mail',
    password: 'Password',
    login: 'Sign In',
    forgot_password: 'Forgot password?',
    cancel: 'Cancel',
    reset_password: 'Reset password',
    enter_name: 'Provide name',
    info: 'info',
    private: 'Private',
    int_connection_lost: 'Internet connection lost!',
    int_connnection_lost_desc: "Your computer seems to be offline. We'll keep trying to reconnect.",
    no_contacts: 'You don’t have any contacts yet.',
    mic_requirted: 'Microphone access required!',
    mic_requirted_desc: 'Connect the microphone and/or grant browser permission to use it!',
    restart_app: 'Restart the app',
    password_must: 'Password must contain',
    password_recovery_strength: 'at least one lowercase letter, uppercase letter, and one digit',
    no_recents: "You don't have any recent calls.",
    no_recents_msg: 'Make first call!',
    listening: 'You’re listening',
    now: 'now',
    ws_disconnection: "Phone network disconnection, we'll keep trying to reconnect",
    ws_reconnection_failed:
        'The App could not reconnect to the server, fix your internet connection and restart application, please',
    language: 'Language',
    select: 'Select',
    nothing_selected: 'Nothing selected',
    numberValidationError: 'Number is not valid!',
    countryNumberValidationError: 'Provided country number is not valid!',
    sessionExpired: 'Session expired',
    auto_reject: 'Auto reject during call',
    auto_reject_tooltip: 'Reject incoming calls automatically while being busy on another call',
    general: 'General',
    field_required: 'Field is required',
    password_validation: {
        lowercase: 'Password must contain at least one lowercase letter',
        uppercase: 'Password must contain at least one uppercase letter',
        digit: 'Password must contain at least one digit',
        length: 'Password must be at least 8 chars long',
        confirmation: "Passwords don't match"
    },
    email_incorrect: 'Provided email address is incorrect',
    version: 'Version',
    auto_pickup: 'Auto pickup (Click2Call)',
    auto_pickup_tooltip: 'Automatically pickup Click2Call calls originated by user',
    notification: {
        call_to: 'Calling To',
        incoming_call: 'Incoming Call',
        tab_focus: 'Focus webphone active tab',
        tab_focus_desc: 'Click at the notification to open webphone'
    },
    multipleTabsTitle: 'Multiple tabs are not allowed!',
    multipleTabsDescription: 'Looks like app is already open at another browser tab/window.',
    focusActive: 'Focus Active',
    forceActive: 'Force Activation',
    inbound_call: 'Inbound call',
    codecs: 'Codecs',
    codecsDescription:
        'Use checkbox to enable/disable codecs. Drag and drop items to change enabled codecs priority (Higher position - higher priority)',
    codecName: 'Name',
    codecRate: 'Rate / Channels',
    hertz: 'Hz',
    open_lead_at: 'Open lead on',
    caller_insights: 'Caller Insights',
    company: 'Company',
    last_modified: 'Last modified',
    owner: 'Owner',
    integration: 'Integration',
    installed_integration: 'Installed integration',
    preferences: 'Preferences',
    search_lead_number: 'Search for leads on calls',
    no_integration: 'No integration installed',
    search_lead_tooltip: 'Search and show lead detailed information when making/receiving calls',
    records_found: 'Records found',
    no_records_found: 'No records found',
    create: 'Create',
    search_kavkomcrm_only: 'Search leads exclusively in Kavkom CRM',
    search_kavkomcrm_tooltip: 'Overrides searching leads in other installed CRM integrations',
    kavkom_crm: 'Kavkom CRM',
    manage_conference: 'Manage',
}
